<!--支付账户开户申请-->
<template>
  <div v-loading="loading">
    <!--    公司基本信息-->
    <company-base-info ref="companyBaseInfo"></company-base-info>
    <!--      申请人信息-->
    <applicant-info ref="applicantInfo"></applicant-info>
    <!--      公司法人信息-->
    <legal-person-info ref="legalPersonInfo"></legal-person-info>
    <!--      公司银行账户信息-->
    <bank-account-info ref="bankAccountInfo"></bank-account-info>
    <!--      统一支付平台操作人员配置-->
    <user-config ref="userConfig"></user-config>
    <!--      ukey收件人信息-->
    <ukey-recipient-info ref="ukeyRecipientInfo"></ukey-recipient-info>
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount/index';
import { paymentAccountOpeningMixins } from '../constant';
import CompanyBaseInfo from './companyBaseInfo';
import ApplicantInfo from './applicantInfo';
import LegalPersonInfo from './legalPersonInfo';
import UserConfig from './userConfig';
import UkeyRecipientInfo from './ukeyRecipientInfo';
import BankAccountInfo from './bankAccountInfo';

export default {
  name: 'PaymentAccountOpening',
  components: {
    CompanyBaseInfo,
    ApplicantInfo,
    LegalPersonInfo,
    UserConfig,
    UkeyRecipientInfo,
    BankAccountInfo,
  },
  mixins: [paymentAccountOpeningMixins],
  data() {
    return {
      loading: false,
    };
  },
  watch: {},
  created() {},
  methods: {
    async initData(tempId) {
      this.loading = true;
      const res = await Api.getEpaySettleAccountApplyEdit(
        tempId ? { tempId } : {}
      ).finally(() => {
        this.loading = false;
      });
      if (res.code === '200') {
        Object.keys(this.defaultForm).forEach((key) => {
          this.defaultForm[key] = res.data[key];
        });
        this.$refs.companyBaseInfo.initData(res.data, this.defaultForm);
        this.$refs.applicantInfo.initData(res.data, this.defaultForm);
        this.$refs.legalPersonInfo.initData(res.data, this.defaultForm);
        this.$refs.userConfig.initData(res.data);
        this.$refs.ukeyRecipientInfo.initData(res.data);
        this.$refs.bankAccountInfo.initData(res.data);
        // this.$nextTick(() => {
        //   this.$refs.ruleForm?.clearValidate();
        // });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../css/paymentAccountOpening.scss';
</style>
